import { Button } from 'omakase';
import { FunctionComponent } from 'react';
import { IconMapMarker } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { IconPin } from 'ui/icons';
import { useButtonStyles } from 'components/patron-location/patronLocationStyles';

export interface PatronLocationComponentProps {
  loading?: boolean;
  locationText?: string;
  onClick?(e: React.MouseEvent<HTMLElement>): void;
}

export const PatronLocationButton: FunctionComponent<PatronLocationComponentProps> = ({
  loading = false,
  locationText,
  onClick,
}) => {
  const buttonClasses = useButtonStyles();
  return (
    <Button
      aria-haspopup
      className={buttonClasses.root}
      disabled={loading}
      onClick={onClick}
      size="medium"
      iconStart={
        <IconMigrationUtil
          legacyIcon={<IconPin fontSize="small" />}
          newIcon={<IconMapMarker fontSize="small" />}
        />
      }
      variant="ghost"
      data-testid="location-button"
    >
      <span className="button-overflow">{loading ? 'Loading' : locationText}</span>
    </Button>
  );
};
